import React, { useState, useEffect } from "react";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Modal, Button, Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";

const HRRrports = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "year").format("YYYY-MM-DD");

  const [loading, setLoading] = useState(true);
  const [reportList, setReportList] = useState([]);
  const [HrReportList, setHrReportList] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [hrList, setHrList] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [showModal, SetShowModal] = useState(false);
  const [selectedModalItem, setSelectedModalItem] = useState([]);
  const [respStatus, setRepStatus] = useState(0);
  const [filterFormData, setFilterData] = useState([
    { label: "HR Name", value: "" },
    { label: "Job Title", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const columns = {
    HRName: { text: "HR Name", visible: true },
    HRInterviews: {
      text: "CIP",
      align: "center",
      visible: true,
      type: "Modal",
    },
    Schedule: {
      text: "Schedule",
      align: "center",
      visible: true,
      type: "Modal",
    },
    Selected: { text: "Select", align: "center", visible: true, type: "Modal" },
    Rejected: { text: "Reject", align: "center", visible: true, type: "Modal" },
    OfferLetterAccepted: {
      text: "Offer Accept",
      align: "center",
      visible: true,
      type: "Modal",
    },
    OfferLetterRejected: {
      text: "Offer Reject",
      align: "center",
      visible: true,
      type: "Modal",
    },
    OnBoard: {
      text: "On Board",
      align: "center",
      visible: true,
      type: "Modal",
    },
  };

  const defaultColumns = {
    ProjectName: true,
    HRName: true,
    HRInterviews: true,
    Schedule: true,
    Selected: true,
    Rejected: true,
    OfferLetterAccepted: true,
    OfferLetterRejected: true,
    OnBoard: true,
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("HR Report"));
  }, []);

  useEffect(() => {
    fetchHrReports();
  }, []);
  const [apiStatus, setApiStatus] = useState(undefined)

  const fetchHrReports = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/7?P_CreatedBy=&P_FromDate=${lastMonthDate}&P_ToDate=${todayDate}`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.hrReport;
        setHrReportList(cleanedData);

        const HRName = response?.data?.data?.hrname?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setHrList(HRName);
        const designation = response?.data?.data?.designation?.map((ele) => ({
          value: ele?.VALUE,
          label: ele?.TEXT,
        }));
        setJobTitle(designation);
        setLoading(false);
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch HR Report. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const formDatas = [
    { name: "HR Name", type: "Select", options: [...hrList] },
    { name: "Job Title", type: "Select", options: [...jobTitle] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
  ];

  const handleChange = (e, name) => {

    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}report/7?P_CreatedBy=${filterFormData.find((o) => o.label === "HR Name")
          ? filterFormData.find((o) => o.label === "HR Name").value
          : 0
        }&P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : lastMonthDate
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : todayDate
        }`
      );
      setApiStatus(response.status)
      if (response.status === 200) {
        const cleanedData = response?.data?.data?.hrReport;
        setHrReportList(cleanedData);

        const HRName = response?.data?.data?.hrname?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setHrList(HRName);
        const designation = response?.data?.data?.designation?.map((ele) => ({
          value: ele?.VALUE,
          label: ele?.TEXT,
        }));
        setJobTitle(designation);
        setLoading(false);
        setRepStatus(response.status);
      } else {
        console.error(
          "Failed to fetch HR Report. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };



  const [modalApiStatus, setModalApiStatus] = useState(undefined)
  const handleModalColumn = async (columnName, item) => {
    SetShowModal(true);
    setSelectedModalItem(item);

    // Debug filterFormData

    const fromDate = filterFormData.find(
      (field) => field.label === "From Date"
    )?.value;
    const toDate = filterFormData.find(
      (field) => field.label === "To Date"
    )?.value;

    // Debug fromDate and toDate

    // Debug formatted dates
    const formattedFromDate = moment(fromDate, "DD-MMM-YYYY").format(
      "YYYY-MM-DD"
    );
    const formattedToDate = moment(toDate, "DD-MMM-YYYY").format("YYYY-MM-DD");

    const statusMapping = {
      HRInterviews: 0,
      Schedule: 1264,
      Selected: 1267,
      Rejected: 1266,
      OfferLetterAccepted: 1322,
      OfferLetterRejected: 1323,
      OnBoard: 1318,
    };

    const status = statusMapping[columnName];

    setModalApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}viewCandidateDetails/2?P_Status=${status}&P_JobDescriptionID=0&` +
        `P_FromDate=${formattedFromDate}&` +
        `P_ToDate=${formattedToDate}&` +
        `P_recruiterID=${item.HRID}`
      );
      setModalApiStatus(response?.status)

      if (response?.status == 200) {
        const ListData = response?.data?.header;
        setReportList(ListData);
      }
    } catch (error) {
      console.error("Error fetching job:", error);
    }
  };

  useEffect(() => { }, [selectedModalItem]);
  const handleEditModalClose = () => {
    SetShowModal(false);
    setCurrentPage(1)

  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reportList.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleReset = () => {
    setFilterData([
      { label: "HR Name", value: "" },
      { label: "Job Title", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    ])

    fetchHrReports()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="crad rounded bg-white" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={HrReportList}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              isSorting={true}
              handleReset={handleReset}
              isFilterRequired={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              formDatas={formDatas}
              responseStatus={respStatus}
              // filterFormData={filterFormData}
              isActionRequired={false}
              isAddNewBtnRequired={false}
              handleGetData={handleGetData}
              handleModalColumn={handleModalColumn}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header" style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #f0f0f0',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px 8px 0 0'
              }}>
                <p style={{
                  fontSize: '20px',
                  fontWeight: '600',
                  color: '#27568B',
                  margin: '0'
                }}>Candidate Details</p>
                <span className="me-2">
                  <i className="bi bi-x-lg" onClick={handleEditModalClose}></i>
                </span>
              </div>
              <div className="modal-body">
                <Table striped hover bordered>
                  <thead id="thcolor">
                    <tr rowSpan={2} className="align-middle text-center">
                      <th>Candidate Name</th>
                      <th>Job Title</th>
                      <th>Experience</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>

                {modalApiStatus === undefined ? (
  // Loading state
  <tr>
    <td colSpan={4} className="text-center">
      <FaSpinner className="spinner" />
    </td>
  </tr>
) : modalApiStatus === 200 && currentItems.length > 0 ? (
  // Data rows
  currentItems.map((item, index) => (
    <tr key={index}>
      <td>{item.FullName}</td>
      <td>{item.JobTitle}</td>
      <td className="text-center">{item.Experience}</td>
      <td>{item.CandidateStatus}</td>
    </tr>
  ))
) : (
  // No data state
  <tr>
    <td colSpan={4} className="text-center">
      No Data Found
    </td>
  </tr>
)}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end">
                  {currentItems.length != 0
                    ? <Pagination
                      itemsPerPage={itemsPerPage}
                      totalItems={reportList.length}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    /> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HRRrports;
